  <!-- <mat-checkbox [(ngModel)]="akcia.prihlaseny" [disabled]="false" (click)="checkboxClick($event)"></mat-checkbox> -->
  <mat-checkbox clas="m-2" [(ngModel)]="studProgram.zaradeny" (click)="checkboxClick($event)">
    {{studProgram.skratka}} - {{studProgram.popis}}
  </mat-checkbox>
